/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
/* eslint-disable import/prefer-default-export */
import React, { useState, useMemo, useRef, useCallback, useEffect } from 'react'

import { FixedSizeList as List } from 'react-window'
import { useMedia } from 'hooks/useMedia'
import clsx from 'clsx'
import LoadingSpinner from 'components/LoadingSpinner'
import { SearchIcon } from './SearchIcon'
import styles from './SubwayStops.module.css'

import { filterOptionsBySearch, filterOptionsForViewSelected } from './utils'
import { DropdownRow } from './components/DropdownRow'
import { DEFAULT_PROPS } from './consts'

export function SubwayStops({ options, initialValues, loading, onChange }) {
  const [search, setSearch] = useState('')
  const [viewSelectedMode, setViewSelectedMode] = useState(false)
  const [selectedValues, setSelectedValues] = useState(initialValues)

  useEffect(() => {
    setSelectedValues(initialValues)
  }, [initialValues])

  const listRef = useRef(null)

  const isMobile = useMedia([DEFAULT_PROPS.MOBILE_BREAKPOINT], [true], false)

  const handleSearchChange = (e) => {
    setSearch?.(e.target.value)
  }

  const optionsList = useMemo(() => {
    const source = viewSelectedMode ? filterOptionsForViewSelected(options, selectedValues) : options
    return source
  }, [viewSelectedMode, options, selectedValues])

  const displayOptions = useMemo(() => {
    if (!search) return optionsList

    return filterOptionsBySearch(optionsList, search)
  }, [optionsList, search])

  const toggleValue = useCallback(
    (value) => {
      const isSelected = selectedValues.includes(value)

      if (isSelected) {
        setSelectedValues((prev) => prev.filter((v) => v !== value))
      } else {
        setSelectedValues((prev) => [...prev, value])
      }
    },
    [selectedValues]
  )

  const itemData = useMemo(
    () => ({
      filteredOptions: displayOptions,
      selectedValues,
      toggleValue,
    }),
    [displayOptions, selectedValues]
  )

  const handleViewSelected = useCallback(() => {
    if (viewSelectedMode) {
      setSelectedValues([])
      setViewSelectedMode(false)
    } else {
      setViewSelectedMode(true)
    }
  }, [viewSelectedMode])

  const handleApply = useCallback(() => {
    onChange?.({
      subwayStops: selectedValues,
    })
  }, [onChange, selectedValues])

  return (
    <div className={styles.root}>
      <div className={styles.searchBar}>
        <SearchIcon />
        <input
          placeholder="Search Subway Stop"
          value={search || ''}
          onChange={handleSearchChange}
          className={styles.searchInput}
          autoComplete="off"
          role="searchbox"
          aria-label="Search Subway Stop"
        />
      </div>

      {loading ? (
        <LoadingSpinner />
      ) : displayOptions?.length > 0 ? (
        <List
          ref={listRef}
          height={
            isMobile
              ? window.innerHeight - DEFAULT_PROPS.MOBILE_HEADER_OFFSET
              : Math.min(displayOptions?.length, DEFAULT_PROPS.maxVisibleItems) * DEFAULT_PROPS.itemHeight
          }
          itemCount={displayOptions.length}
          itemSize={DEFAULT_PROPS.itemHeight}
          width="100%"
          itemData={itemData}
        >
          {DropdownRow}
        </List>
      ) : (
        <div className={styles.noResults} role="status">
          No Results
        </div>
      )}

      <div className={styles.footer}>
        <button
          className={clsx(styles.viewSelectedButton, selectedValues?.length > 0 && styles.viewSelectedButtonActive)}
          type="button"
          onClick={handleViewSelected}
          disabled={selectedValues?.length === 0 && !viewSelectedMode}
        >
          {viewSelectedMode ? 'Clear All' : 'View Selected'}
        </button>

        <div className={styles.divider} />

        <button className={styles.applyButton} type="button" onClick={handleApply}>
          Apply {selectedValues?.length > 0 && `(+${selectedValues?.length})`}
        </button>
      </div>
    </div>
  )
}
